import { isEqual, omit } from 'lodash-es';
import { isUrlValid } from '~/utils/videoUrl/videoUrl';
import { toCustomPageDTO } from './translator';
export function matchCustomPage(page, visitor) {
    switch(page.type){
        case 'text':
            return visitor.text(page);
        case 'pdf':
            return visitor.pdf(page);
        case 'video':
            return visitor.video(page);
    }
}
export function matchCustomPageType(type, visitor) {
    switch(type){
        case 'text':
            return visitor.text();
        case 'pdf':
            return visitor.pdf();
        case 'video':
            return visitor.video();
    }
}
export const isProposalAndAgreement = (page)=>page.displayScope === 'proposalAndAgreement';
export const supportsDisplayScope = (page)=>page.type !== 'video';
export const isShownOnAgreement = (page)=>isProposalAndAgreement(page) && supportsDisplayScope(page);
export const sortedPages = (pages)=>[
        ...pages
    ].sort((a, b)=>a.displayOrder - b.displayOrder);
export const agreementPages = (pages)=>sortedPages(pages.filter(isShownOnAgreement));
export function isCustomPageContentEdited(current, original) {
    if (original == null) return false;
    return matchCustomPage(current, {
        text: (textPage)=>original.type === 'text' && textPage.text.textId !== original.text.textId,
        pdf: (pdfPage)=>original.type === 'pdf' && (pdfPage.pdf.pdfName !== original.pdf.pdfName || pdfPage.pdf.pdfFileName !== original.pdf.pdfFileName),
        video: ()=>false
    });
}
export const isCustomPageEmpty = (page)=>matchCustomPage(page, {
        text: (textPage)=>textPage.text.textId === '' || textPage.text.isEmpty === true,
        pdf: (pdfPage)=>pdfPage.pdf.pdfName === '' || pdfPage.pdf.pdfFileName === '',
        video: (videoPage)=>videoPage.video.videoUrl === ''
    });
const hasFailedTextSave = (page)=>page.type === 'text' && page.text.saveFailed === true;
const hasUnsupportedVideoUrl = (page)=>page.type === 'video' && !isUrlValid(page.video.videoUrl);
const hasUnsavedTextContent = (page)=>page.type === 'text' && page.text.isEmpty === false && page.text.textId === '';
export const isCustomPageContentInvalid = (page, options)=>{
    if (isCustomPageEmpty(page)) {
        return (options === null || options === void 0 ? void 0 : options.allowEmpty) !== true || hasFailedTextSave(page) || hasUnsavedTextContent(page);
    }
    return hasFailedTextSave(page) || hasUnsupportedVideoUrl(page);
};
export const isSameCustomPage = (a, b)=>isEqual(omit(toCustomPageDTO(a), 'displayOrder'), omit(toCustomPageDTO(b), 'displayOrder'));
